import { render } from "./WeChatCallback.vue?vue&type=template&id=7337b75d"
import script from "./WeChatCallback.vue?vue&type=script&lang=js"
export * from "./WeChatCallback.vue?vue&type=script&lang=js"
script.render = render

export default script